import { motion } from "motion/react";

export const PlaceholderSection = ({ id, eyebrow, title }) => {
  return (
    <section id={id} className="max-w-6xl mx-auto px-6 py-24 md:py-32" data-testid={`section-${id}`}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">{eyebrow}</p>
        <h2 className="font-serif-display text-lg md:text-lg text-white font-medium mb-6">{title}</h2>
        <div className="liquid-glass-strong rounded-3xl p-10 md:p-14">
          <p className="text-sm text-white/60 italic">Próximamente · Esta sección se llenará pronto.</p>
        </div>
      </motion.div>
    </section>
  );
};
